const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

async function jsonFetch(path, opts) {
  const r = await fetch(`${API}${path}`, opts);
  const body = await r.json().catch(() => null);
  if (!r.ok) {
    const err = new Error((body && body.detail && body.detail.error) || `HTTP ${r.status}`);
    err.status = r.status;
    err.body = body;
    throw err;
  }
  return body;
}

export const pairApi = {
  coins: () => jsonFetch("/coins"),
  symbols: () => jsonFetch("/symbols"),
  snapshot: (symbol) => jsonFetch(`/pair/${encodeURIComponent(symbol)}/snapshot`),
  ticker: (symbol) => jsonFetch(`/pair/${encodeURIComponent(symbol)}/ticker`),
  resolve: (a, b) => jsonFetch(`/pair/resolve?a=${encodeURIComponent(a)}&b=${encodeURIComponent(b)}`),
};
